"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwToolbarFill = _interopRequireDefault(require("./CwToolbarFill.scss"));

var CwToolbarFill =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwToolbarFill, _React$Component);

  function CwToolbarFill() {
    (0, _classCallCheck2.default)(this, CwToolbarFill);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwToolbarFill).apply(this, arguments));
  }

  (0, _createClass2.default)(CwToolbarFill, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        className: _CwToolbarFill.default.toolbarFill
      });
    }
  }]);
  return CwToolbarFill;
}(_react.default.Component);

CwToolbarFill.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string
};
var _default = CwToolbarFill;
exports.default = _default;